import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Popout from './popout';
import Tooltip from './tooltip';

const PermissionRule = props => {
    const handleSelect = () => {
        props.onSelect && props.onSelect(props.id);
    }

    return (
        <li
            className={props.selected ? 'selected' : ''}
            onClick={handleSelect}
        >
            <span className="check">
                <i className="ion ion-checkmark-round" />
            </span>

            { props.title }
        </li>
    )
}

export default class UserPermissionSelector extends PureComponent {
    static propTypes = {
        visible: PropTypes.bool,
        userId: PropTypes.string,
        permissions: PropTypes.array,
        permission: PropTypes.string,
        successText: PropTypes.string,
        onRemove: PropTypes.func,
        onSuccess: PropTypes.func,
        onShow: PropTypes.func,
        onHide: PropTypes.func,
        provideController: PropTypes.func
    };

    static defaultProps = {
        successText: 'Update'
    };

    state = {
        selectedPermission: this.props.permission || this.props.permissions[0].id
    };

    handleSelect = permission => {
        this.setState({
            selectedPermission: permission
        });
    }

    handleRemoveClick = () => {
        this.props.onRemove && this.props.onRemove(this.props.userId);

        this.hide();
    }

    handleCancelClick = () => {
        this.hide();
    }

    handleSuccessClick = () => {
        this.props.onSuccess && this.props.onSuccess(this.props.userId, this.state.selectedPermission || this.props.permission);

        this.hide();
    }

    show() {
        this.popoutCtrl && this.popoutCtrl.show();
    }

    hide() {
        this.popoutCtrl && this.popoutCtrl.hide();
    }

    componentDidMount() {
        this.props.provideController && this.props.provideController({
            show: () => {
                this.show();
            },
            hide: () => {
                this.hide();
            }
        });
    }

    componentWillUnmount() {
        this.hide();
        this.props.provideController && this.props.provideController(null);
    }

    render() {
        return (
            <Popout
                className="no-arrow"
                visible={this.props.visible}
                closeOnEveryClick={true}
                provideController={ctrl => this.popoutCtrl = ctrl}
                onShow={this.props.onShow}
                onHide={this.props.onHide}
            >
                <div className="popout-main">
                    <ul className="popout-checklist">
                        {
                            this.props.permissions.map(permission => <PermissionRule
                                key={permission.id}
                                id={permission.id}
                                title={permission.title}
                                selected={(this.state.selectedPermission || this.props.permission) === permission.id}
                                onSelect={this.handleSelect}
                            />)
                        }
                    </ul>
                </div>

                <div className="popout-foot">
                    {
                        this.props.onRemove ? (
                            <Tooltip tooltip="Remove from Doc">
                                <button className="btn btn-icon btn-small" onClick={this.handleRemoveClick}>
                                    <i className="ion ion-android-delete" />
                                </button>
                            </Tooltip>
                        ) : null
                    }

                    <div className="popout-actions">
                        <button className="btn btn-small btn-secondary" onClick={this.handleCancelClick}>Cancel</button>

                        <button className="btn btn-small btn-success" onClick={this.handleSuccessClick}>{this.props.successText}</button>
                    </div>
                </div>
            </Popout>
        )
    }
}